import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import SweetAlert from "react-bootstrap-sweetalert";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import Tooltip from "@material-ui/core/Tooltip";
// import uploadProfileImage from "utils/api/profile/uploadProfileImage";
import updateUserImage from "api/profile/updateUserImage";

export default class ProfilePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      showPopup: false,
      popupTitle: "",
      popupText: "",
      popupSuccess: true,
      imagePreviewUrl: null
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.setAlert = this.setAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  setAlert(title, message, popupSuccess) {
    this.setState({
      showPopup: true,
      popupTitle: title,
      popupText: message,
      popupSuccess
    });
  }

  hideAlert() {
    this.setState({ showPopup: false });
  }

  handleClick() {
    // eslint-disable-next-line react/no-string-refs
    this.refs.fileInputUserImage.click();
  }

  handleImageChange(e) {
    const t = this.props.t;
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      if (file.size >= 2097152) {
        this.setAlert(
          t("editPictures.file_too_big_title"),
          t("editPictures.file_too_big_text"),
          false
        );
      } else {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        });
        // let width = 0;
        // let height = 0;
        const image = new Image();
        image.src = reader.result;
        image.onload = img => {
          // width = img.path[0].width;
          // height = img.path[0].height;
          const data = {
            // width: width,
            // height: height,
            avatar: reader.result,
            type: "profileImageUrl"
            // language: this.props.language
          };
          return updateUserImage(data, this.props.tokens)
            .then(res => {
              if (res && res.url) {
                const user = this.props.user;
                user.profileImageUrl = res.url;
                this.props.updateUser(user);
                this.setAlert(
                  t("editProfile.saved_success_title"),
                  t("editProfile.saved_success_text"),
                  true
                );
              } else {
                this.setAlert(
                  t("editProfile.upload_image_error_title"),
                  t("editProfile.upload_image_error_text"),
                  false
                );
              }
              // this.props.editPictures(res.url, this.props.type);
            })
            .catch(err => {
              // eslint-disable-next-line no-console
              console.log("err", err);
              this.setAlert(
                t("editProfile.upload_image_error_title"),
                t("editProfile.upload_image_error_text"),
                false
              );
            });
        };
      }
    };
    reader.readAsDataURL(file);
  }

  render() {
    const { classes, user, t } = this.props;
    let name = "";
    if (user.firstName && user.lastName) {
      if (user.middleName) {
        name = user.firstName + " " + user.middleName + " " + user.lastName;
      } else {
        name = user.firstName + " " + user.lastName;
      }
    } else {
      name = user.username;
    }
    return (
      <Card style={{ marginTop: "0px" }} className={classes.cardHover}>
        {this.state.showPopup ? (
          <SweetAlert
            success={this.state.popupSuccess}
            warning={!this.state.popupSuccess}
            style={{ display: "block", marginTop: "-100px" }}
            title={this.state.popupTitle}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {this.state.popupText}
          </SweetAlert>
        ) : null}
        <CardAvatar profile>
          <div
            style={{
              backgroundImage: `url("${user.profileImageUrl}")`,
              width: "130px",
              height: "130px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "50%",
              position: "relative",
              cursor: "pointer"
            }}
            onClick={() => {
              this.handleClick();
            }}
            onMouseOver={() => {
              if (
                document &&
                document.getElementById("user-change-profile-image")
              ) {
                document.getElementById(
                  "user-change-profile-image"
                ).style.display = "block";
              }
            }}
            onMouseOut={() => {
              if (
                document &&
                document.getElementById("user-change-profile-image")
              ) {
                document.getElementById(
                  "user-change-profile-image"
                ).style.display = "none";
              }
            }}
          >
            <input
              type="file"
              onChange={this.handleImageChange}
              ref={`fileInputUserImage`}
              style={{ display: "none" }}
            />
            <div
              id={"user-change-profile-image"}
              style={{
                position: "absolute",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
                textAlign: "center",
                color: "#ffffff",
                lineHeight: "130px",
                fontSize: "40px",
                display: "none"
              }}
            >
              <Tooltip
                id="tooltip-top"
                title={t("editProfile.edit_profile_picture")}
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
                disableTouchListener
              >
                <i className="icon icon-photo-24" />
              </Tooltip>
            </div>
          </div>
        </CardAvatar>
        <CardBody>
          <div style={{ width: "100%", textAlign: "center" }}>
            <div
              style={{ color: "#999999", fontSize: "14px", lineHeight: "20px" }}
            >
              OWNER
            </div>
            <div
              style={{ color: "#3c4858", fontSize: "18px", lineHeight: "20px" }}
            >
              {name}
            </div>
          </div>
          <GridContainer style={{ margin: "30px -15px" }} justify="center">
            {user.description ? (
              <GridItem
                xs={12}
                style={{
                  color: "#3c4858",
                  fontSize: "14px",
                  lineHeight: "18px",
                  textAlign: "center"
                }}
              >
                {user.description}
              </GridItem>
            ) : null}
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

ProfilePreview.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  tokens: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  updateUser: PropTypes.func.isRequired,
  updateUserState: PropTypes.func.isRequired
};
